import { actions, FETCH_DEFAULTS_CALL_REQUEST } from './duck';

import { takeLatest, call, put } from 'redux-saga/effects';

import XlinkAPI from '~/app/api/xlinkAPI';
import ErrorHelpers from '~/app/errorHelpers.js';

export function* watcherSagaDefaultsPage() {
  yield takeLatest(FETCH_DEFAULTS_CALL_REQUEST, workerSagaDefaultsPage);
}

export function* workerSagaDefaultsPage(payload) {
  try {
    const res = yield call(XlinkAPI.getDefaultsSetup, payload.loginID);

    yield put(actions.requestDefaultsConfigSuccess(res.data.config, payload.season));
  } catch (error) {
    let errTitle = 'Error Fetching Defaults Configuration';

    if (error?.response?.data?.details) {
      errTitle = error?.response?.data?.details;
    }

    ErrorHelpers.handleError(errTitle, error);
    yield put(actions.requestDefaultsConfigError());
  }
}
